import { Modal } from "components/molecules";
import { CloseIcon } from "components/atoms/Icon";
import { Button, Typography } from "components/atoms";
import { decodeToken } from "utils/functions/decodeToken";
import "./unlock-modal.scss";

interface IProps {
  handleUnlockModalClose: () => void;
  handleUpgrade: () => void;
  unlockModalState: any;
  theme: "light" | "dark";
}

export const UnlockModal = ({
  handleUnlockModalClose,
  handleUpgrade,
  unlockModalState,
  theme,
}: IProps) => {
  const payload = decodeToken();

  const testType = payload ? payload.testtype : null;

  return (
    <Modal
      onClose={handleUnlockModalClose}
      isOpen={unlockModalState}
      theme={theme}
      style="unlock-modal-style"
    >
      <div className="unlock-modal-content-wrapper">
        <div className="unlock-modal-header-wrapper">
          <div className="title-wrapper">
            <Typography
              label={`Unlock ${testType} Self-Paced`}
              variant="h4Bold"
            />
          </div>
          <CloseIcon onClick={handleUnlockModalClose} theme={theme} />
        </div>
        <div className="unlock-modal-body-wrapper">
          <Typography
            variant="h7Book"
            label="You must upgrade in order to gain access to all locked content."
          />
          <Button
            icon={false}
            type="score"
            label="Upgrade Self-Paced Course"
            styles="unlock-btn-custom-style"
            onClick={handleUpgrade}
          />
          <Typography
            label="Later"
            variant="h7Med"
            styles="later-text-custom-style"
            onClick={handleUnlockModalClose}
          />
        </div>
      </div>
    </Modal>
  );
};
